export type BannerButtonVariant = 'Primary' | 'Secondary';
export type BannerButtonAligment = 'Left' | 'Center' | 'Right';
export type BannerLinkType = 'Product' | 'Category';

export class PromotionalBannerData {
    button: { text: string; target: string; url: string };
    buttonAlignment: { value: BannerButtonAligment };
    buttonVariant: { value: BannerButtonVariant };
    desktopBackground: { alt: string; src: string };
    mobileBackground: { alt: string; src: string };
    text: { value: string };
    title: { value: string };
    linkType: { value: BannerLinkType };
    linkTypeValue: { value: number };
}
